import {RouteLeafControls} from "@/my-leaf/routes/route-leaf-controls";
import L from "leaflet";
import {eventBus, routes_map} from "@/main";
import store from "@/store";
import i18n from "@/i18n";
import GeometryUtil from "leaflet-geometryutil";
import * as legs from "@/my-leaf/routes/components/route-legs";
import * as waypoints from "@/my-leaf/routes/components/route-waypoints";
import dayjs from "dayjs";
import {myAxios} from "@/services/myAxios";
import {getWeather} from "@/my-leaf/routes/components/route-utils";
import { GeoUtils } from "@/utils/geo-utils";
import { ContextMenu, ContextMenuItem } from "@/utils/context-menu";

L.TileLayer.FetchTokenLayer = L.TileLayer.extend({
    initialize: function (url, options) {
        this._token = options.token;
        L.TileLayer.prototype.initialize.call(this, url, options);
    },
    createTile: function (coords, done) {
        const tile = document.createElement('img');
        tile.alt = '';
        tile.setAttribute('role', 'presentation');

        tile.onload = function () {
            done(null, tile);
        };

        tile.onerror = function (err) {
            done(err, tile);
        };

        const url = this.getTileUrl(coords);
        fetch(url, {
            headers: {
                'Authorization': 'Bearer ' + this._token
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then(blob => {
                tile.src = URL.createObjectURL(blob);
            })
            .catch(err => {
                console.error(err);
                done(err, tile);
            });

        return tile;
    }
});

L.tileLayer.fetchTokenLayer = function (url, options) {
    return new L.TileLayer.FetchTokenLayer(url, options);
};

let objectsPolyline = L.layerGroup();
let pointsLayer = L.featureGroup();

export class RouteLeafDraw extends RouteLeafControls {
    wpGroup = null
    legsGroup = null
    wpGeneralRouteGroup = null
    bigDataRouteGroup = null
    bypassGroup = null
    dangerMarkersGroup = null
    contextButtonsCount = 0
    logbookGroup = null
    nogoZonesGroup = null

    drawControl = null
    nogoList = null

    ukcSafeDepth = -1
    ukcWPIndex = -1

    isDevBuild() {
        return (location.hostname === "localhost") || (process.env.VUE_APP_DEVBUILD === 'true');
    }

    async initbasewp(el) {
        await super.initbasecontrols(el);

        this.dangerMarkersGroup = L.layerGroup();
        this.map.addLayer(this.dangerMarkersGroup);

        this.bypassGroup = L.layerGroup();
        this.map.addLayer(this.bypassGroup);

        this.bigDataRouteGroup = L.layerGroup();
        this.map.addLayer(this.bigDataRouteGroup);

        this.wpGeneralRouteGroup = L.layerGroup();
        this.map.addLayer(this.wpGeneralRouteGroup);

        this.legsGroup = L.layerGroup();
        this.map.addLayer(this.legsGroup);

        this.wpGroup = L.layerGroup();
        this.map.addLayer(this.wpGroup);

        this.previewLayerGroup = L.layerGroup();
        this.map.addLayer(this.previewLayerGroup);

        this.logbookGroup = L.layerGroup();
        this.map.addLayer(this.logbookGroup);

        this.nogoZonesGroup = L.layerGroup();
        this.map.addLayer(this.nogoZonesGroup);

        this.nogoList = new L.FeatureGroup();
        this.map.addLayer(this.nogoList);

        this.map.addLayer(pointsLayer);
        this.map.addLayer(objectsPolyline);

        let options = {
            position: 'topleft',
            draw: {
                polyline: false,
                circle: false,
                polygon: false,
                marker: false,
                rectangle: {shapeOptions: {color: '#f357a1', weight: 1}},
                circlemarker: false
            },
            edit: {
                featureGroup: this.nogoList,
                remove: true
            }
        };

        this.drawControl = new L.Control.Draw(options)
        this.map.on('draw:created', (e) => {
            let type = e.layerType,
                layer = e.layer;

            console.log('draw:created', type, layer);
            this.nogoList.addLayer(layer);
        });

        eventBus.$off('map-drag')
        eventBus.$on('map-drag', () => {
        })

        eventBus.$off('show-dangers-in-wp')
        eventBus.$on('show-dangers-in-wp', (id) => {
            this.dangerMarkersGroup.clearLayers()
            if (id !== -1) {
                this.routesStore.getShipLegHazards(id).forEach(obj => {
                    if (obj.isDanger) {

                        this.setDangerMarkers(obj.points, 'danger');
                    }
                })
            }
        })

        this.map.on('zoomend', () => {
            const zoom = this.map.getZoom();

            this.map.removeLayer(this.dangerMarkersGroup);


            if (zoom >= 14) {
                this.map.addLayer(this.dangerMarkersGroup)

            }
        })

        this.drawLogbookState()
    }

    clearDangerObject() {
        objectsPolyline.clearLayers()
        pointsLayer.clearLayers()
    }

    drawDangerObject(payload) {
        let lines = payload.lines
        let type = payload.type
        let needZoom = payload.zoom

        if (type === "point") {
            let objectCircle = new L.circle([lines[0][0].lat, lines[0][0].lon], 10)
            this.map.addLayer(pointsLayer)
            objectCircle.addTo(pointsLayer);
        }

        objectsPolyline.clearLayers()

        if (type === 'line') {
            let object = new L.Polyline(lines, {
                color: '#5e00ff',
                weight: 3,
                opacity: 1,
                smoothFactor: 1
            });
            object.addTo(objectsPolyline)

        } else {
            let object = new L.Polygon(lines, {
                color: '#5e00ff',
                weight: 3,
                opacity: 1,
                smoothFactor: 1
            });
            object.addTo(objectsPolyline)
        }

        if (needZoom) {
            let allCoordinates = []
            lines.forEach(line => {
                line.forEach(point => {
                    allCoordinates.push([point.lat, point.lon])
                })
            })

            let p
            if (type === 'line') {
                p = L.polyline(allCoordinates)
            } else {
                p = L.polygon(allCoordinates)
            }

            let b = p.getBounds()
            this.map.fitBounds(b)
        }
    }

    setDangerMarkers = (points, type) => {
        points.forEach(pt => {

            let markerDanger = new L.circleMarker([pt.lat, pt.lon], {
                bubblingMouseEvents: false,
                autoPan: true,
                radius: 8,
                weight: 1,
                color: 'red',

            }).addTo(this.dangerMarkersGroup);
        })
    }

    addNoGoLayer() {
        if (this.navalLayer) this.navalLayer.remove();
        let draught = this.routesStore.getShipNoGo

        let text = "<span class='chart-text'>&nbsp;" + i18n.t('map.nogo') + draught + i18n.t('map.m') + "&nbsp;&nbsp;</span>"
        if (this.ukcWPIndex !== -1)
            text = "<span class='chart-text'>&nbsp;WP" + this.ukcWPIndex + ", NoGo: " + draught + " m&nbsp;&nbsp;</span>"

        if (this.nogoText && this.nogoText.updateContent) {
            this.nogoText.updateContent(text);
        } else {
            console.warn('addNoGoLayer: nogoText not ready');
        }

        let deviceId = this.deviceStore.getDeviceID
        let useGoodTiles = this.routesStore.getShipUseGoodTiles

        let url = ''
        if (useGoodTiles === true)
            url = "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" + draught;
        else {
        if (deviceId === '')
            deviceId = '0'
        url = "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" + draught + "&deviceId=" + deviceId;
    }

    if (!this.map) {
        console.warn('addNoGoLayer: map is null, cannot set min zoom');
        return;
    }
    this.map.setMinZoom(2);

    let token = store.state.auth.user.token

        this.navalLayer = L.tileLayer.fetchTokenLayer(url, {
            token: token,
            minZoom: 8,
            maxZoom: 20
        }).addTo(this.map);

    }

    clearBigDataRouteLayers() {
        this.bigDataRouteGroup?.clearLayers()
    }

    clearGeneralRouteLayers() {
        this.previewLayerGroup?.clearLayers()
    }

    getWaypointsLayers() {
        return [
            this.bypassGroup,
            this.wpGeneralRouteGroup,
            this.wpGroup,
            this.legsGroup
        ].filter(Boolean);
    }

    removeWaypointsLayers() {
        const waypointsLayers = this.getWaypointsLayers();
        waypointsLayers.forEach(l => this.map?.removeLayer?.(l));
    }

    addWaypointsLayers() {
        const waypointsLayers = this.getWaypointsLayers();
        waypointsLayers.forEach(l => this.map?.addLayer?.(l));
    }

    clearRoute(clearGeneralRoute = true, clearBypassBackup = true, clearStore = true) {
        if (!this.isInitialized) {
            console.warn('clearRoute: map not initialized yet, skipping');
            return;
        }

        if (this.previewLayerGroup) {
            this.clearGeneralRouteLayers();
        }
        
        if (clearGeneralRoute) {
            this.clearGeneralRouteLayers();
            this.clearBigDataRouteLayers();
        }

        // Защищаем от null/undefined групп слоев
        if (this.wpGeneralRouteGroup) this.wpGeneralRouteGroup.clearLayers();
        if (this.wpGroup) this.wpGroup.clearLayers();
        if (this.legsGroup) this.legsGroup.clearLayers();
        if (this.bypassGroup) this.bypassGroup.clearLayers();
        if (this.dangerMarkersGroup) this.dangerMarkersGroup.clearLayers();
        if (objectsPolyline) objectsPolyline.clearLayers();
        if (pointsLayer) pointsLayer.clearLayers();

        this.waypoints = [];
        this.selectedWaypointIndex = undefined; 
        this.isBaypassMode = false
        this.selecteBaypassWaypoints = []
        this.isAutoroutingCancel = false
        this.contextButtonsCount = 0

        if (clearStore)
            this.routesStore.resetShip()

        if (clearBypassBackup)
            this.routesStore.resetShipBypassBackup()

        eventBus.$emit('clear-order')
        eventBus.$emit('clear-order1')
        eventBus.$emit('route-cleared')

        this.drawMapLayers();
    }

    clearBypass() {
        this.bypassGroup.clearLayers()
        this.selecteBaypassWaypoints = []
        waypoints.refreshWaypointsTooltips.call(this)
    }

    refreshSelectedWaypointIndex() {
        if (this.waypoints.length > 0) {
            let newIndex = this.selectedWaypointIndex > 0 ? this.selectedWaypointIndex - 1 : 0;
            this.selectWaypoint(newIndex)
        }
    }

    changeSelectedWaypoint(direction) {
        if (direction == "left") {
            if (this.selectedWaypointIndex - 1 >= 0) {
                let newWaypointIndex = this.selectedWaypointIndex - 1
                this.selectWaypoint(newWaypointIndex)
                eventBus.$emit('move-prev')
            }
        } else {
            if (this.selectedWaypointIndex + 1 < this.waypoints.length) {
                let newWaypointIndex = this.selectedWaypointIndex + 1
                this.selectWaypoint(newWaypointIndex)
                eventBus.$emit('move-next')
            }
        }
    }

    dateu(seconds) {
        let date = this.routesStore.getShipStartDate
        let time = this.routesStore.getShipStartTime
        let datetime = dayjs(date + " " + time, "YYYY-MM-DD HH:mm")
        let datetimenew = datetime.add(seconds, "seconds")
        let shortdate = datetimenew.unix()

        return shortdate
    }

    zoomToWaypoint(id, maxZoom, showWeather = false, showUKC = false) {
        if (id === null || id === undefined || id < 0 || id >= this.waypoints.length)
            return;

        const waypoint = this.waypoints[id];
        this.ukcWPIndex = id
        this.ukcSafeDepth = showUKC ? this.routesStore.getShipWaypoints[id].ukc?.safeDepth : this.routesStore.getShipNoGo
        let prevZoom = this.map.getZoom()
        let newZoom = prevZoom

        this.map.setView([waypoint.getLatLng().lat, waypoint.getLatLng().lng], newZoom, {animate: false})

        if (showWeather && !this.isUKCmode) {
            let time = this.routesStore.getShipStartDate + ' ' + this.routesStore.getShipStartTime
            let datetime = this.dateu(this.routesStore.getShipLegInfo(id).fromStartSeconds ?? 0)
            getWeather.call(this, waypoint.getLatLng(), datetime)
        } else if (this.isUKCmode) {
            let content = 'UKC: ' + (this.routesStore.getShipWaypoints[id].ukc?.ukc ?? '-') + ' m' + '<br>'
            content += 'Safe depth:' + (this.routesStore.getShipWaypoints[id].ukc?.safeDepth ?? '-') + ' m'
            L.popup().setLatLng(waypoint.getLatLng()).setContent(content).openOn(this.map);
        }
    }

    selectWaypoint(id) {

        this.selectedWaypointIndex = id
        this.refreshControls()
        this.zoomToWaypoint(id, 14)

        eventBus.$emit('wp-control-select-wp', id)
        eventBus.$emit('select-routetable-row', id)

        this.waypoints.forEach(waypoint => {
            let color = waypoints.getWaypointColor.call(this, waypoint.options.id)
            if (id === waypoint.options.id) {
                waypoint.options.isSelected = true
                waypoint.setStyle({color: 'white'});

            } else {
                waypoint.options.isSelected = false
                waypoint.setStyle({color: color});
            }
        })
    }

    changeWaypointCoordinates(index, coordinates, needPan = true) {
        this.waypoints[index].setLatLng(GeoUtils.normalizedLatLng(coordinates));
        legs.clearLegs.call(this)
        legs.drawLegs.call(this)
        this.map.closePopup()

        if (needPan)
            this.map.panTo(this.waypoints[index].getLatLng())
    }

    moveWaypoint(direction, waypointIndex = -1, needPan = true) {
        if (waypointIndex === -1)
            waypointIndex = this.selectedWaypointIndex

        let scale = L.control.scale()
        let meters = scale._getRoundNum(this.map.containerPointToLatLng([0, this.map.getSize().y / 2]).distanceTo(this.map.containerPointToLatLng([scale.options.maxWidth, this.map.getSize().y / 2])))
        let radius = meters / 5
        let currentCoordinates = this.waypoints[waypointIndex].getLatLng();
        let coordinates = GeometryUtil.destination(currentCoordinates, direction, radius);
        
        if (direction == 270 || direction == 90) {
            // keep the sign of lng unchanged, do not wrap around 180
            const delta = GeometryUtil.destination(L.latLng(currentCoordinates.lat, 0), direction, radius);
            coordinates = L.latLng(currentCoordinates.lat, currentCoordinates.lng + delta.lng);
        }

        this.changeWaypointCoordinates(waypointIndex, coordinates, needPan)
        eventBus.$emit('wp-control-toggle-check-safety', true);
    }

    moveLeg(direction) {
        let wp1 = this.selectedWaypointIndex
        let wp2 = this.selectedWaypointIndex + 1

        if (wp2 < this.waypoints.length) {
            this.moveWaypoint(direction, wp2, false)
        }
        this.moveWaypoint(direction, wp1)
    }

    deleteWaypoint() {
        if (this.selectedWaypointIndex > 0) {
            eventBus.$emit('move-prev');
        }

        waypoints.removeWP.call(this, this.selectedWaypointIndex)
    }

    drawStartFinish(coordinates, type) {
        let text = type === 0 ? "<div style='color:#16ba16;'>Start</div>" : "<div style='color:#eda405;'>Finish</div>"
        waypoints.drawFromToPoints.call(this, coordinates, text)
    }

    drawBaypassStartFinish(coordinates, type) {
        let text = this.selecteBaypassWaypoints.length === 1 ? 'Start bypass' : 'Finish bypass'
        waypoints.drawBaypassPoints.call(this, coordinates, text)
    }

    drawBigDataRoute() {
        let globalRoute = []
        const bigDataRoute = this.routesStore.bigDataRoute || [];
        bigDataRoute.forEach(wp => {

            globalRoute.push([wp.lat, wp.lon])
        })

        if (!globalRoute.length) return;
        
        let routeLine = L.polyline(globalRoute, {
            color: 'blue',
            weight: 2,
            dashArray: '5, 5',
            dashOffset: '0'
        }).addTo(this.bigDataRouteGroup);

        let bounds = routeLine.getBounds()
        this.map.fitBounds(bounds);
    }

    panToCoordinates(coordinates, zoom = 8) {
        this.map.setView([coordinates.lat, coordinates.lon], zoom);
    }

    setTileLayerWithWeather(type, unixdatetime) {
        if (this.navalLayer) this.navalLayer.remove();
        const url = "https://nogotiles.bgeo.fi:6011/" + type + "/{z}/{x}/{y}?t=" + unixdatetime;
        this.map.setMinZoom(4)
        this.navalLayer = L.tileLayer(url, {
            minZoom: 4,
            maxZoom: 20,
        }).addTo(this.map)
    }

    showDepths = (coordinates) => {
        myAxios.get(`api/v1/route/depth_info?lat=${coordinates.lat}&lon=${coordinates.lng}&radius=5`)
            .then(resp => {
                this.depthsList.clearLayers()
                let geoJsonLayer = L.geoJson(resp.data, {
                    style: function (feature) {
                        return feature.properties && feature.properties.style;
                    },
                    onEachFeature: function (f, l) {
                        delete f.properties.style
                        l.bindPopup('<pre>' + JSON.stringify(f.properties, null, ' ').replace(/[\{\}"]/g, '') + '</pre>');
                    }
                }).addTo(this.depthsList)
            });
    }

    clearInfoObjects() {
        objectsPolyline.clearLayers()
        pointsLayer.clearLayers()
    }

    drawInfoObject(payload) {

        this.clearInfoObjects()

        let lines = payload.lines
        let type = payload.type
        let needZoom = payload.zoom

        if (type === "point") {
            let objectCircle = new L.circle([lines[0][0].lat, lines[0][0].lon], 10)
            this.map.addLayer(pointsLayer)
            objectCircle.addTo(pointsLayer);

        }

        objectsPolyline.clearLayers()

        if (type === 'line') {
            let object = new L.Polyline(lines, {
                color: '#5e00ff',
                weight: 3,
                opacity: 1,
                smoothFactor: 1
            });
            object.addTo(objectsPolyline)

        } else {
            let object = new L.Polygon(lines, {
                color: '#5e00ff',
                weight: 3,
                opacity: 1,
                smoothFactor: 1
            });
            object.addTo(objectsPolyline)

        }

        if (needZoom) {
            let allCoordinates = []
            lines.forEach(line => {
                line.forEach(point => {
                    allCoordinates.push([point.lat, point.lon])
                })
            })


            let p
            if (type === 'line') {
                p = L.polyline(allCoordinates)
            } else {
                p = L.polygon(allCoordinates)
            }

            let b = p.getBounds()
            this.map.fitBounds(b)
        }
    }

    drawLogbookState() {
        if (!this.map || !this.logbookGroup) {
            console.warn('drawLogbookState: map or logbookGroup is null');
            return;
        }
        
        this.logbookGroup.clearLayers();

        if (this.logbookStore.getLogsCount > 0) {
            let report = this.logbookStore.getLatestShipLog


            let iconImg = require("../../assets/ship_1tx_green.png")
            let icon = L.icon({
                iconUrl: iconImg,
                iconSize: [20, 40],
                iconAnchor: [10, 20],
            });

            let text = dayjs(report.time).format("YYYY-MM-DD HH:mm:ss") + '<br>'
            let positionMarker = new L.marker([report.pos.lat, report.pos.lon], {
                icon: icon,
                rotationAngle: Number(report.hdg / 2)
            });

            positionMarker.bindTooltip(text, {permanent: true, direction: 'top', offset: L.point(0, -17)})
            positionMarker.addTo(this.logbookGroup);
        }
    }

    restoreRoute() {
        if (this.routesStore.getShipWaypointsCount > 0) {
            this.redrawRoute()
        }
    }

    boundRoute() {
        if (!this.map) {
            console.warn('boundRoute: map is null, cannot bound route');
            return;
        }
        
        if (this.routesStore.getShipWaypointsCount > 0) {
            const allPoints = this.routesStore.getShipWaypoints;

            const sameHemiPoints = allPoints.map(p => GeoUtils.toPointHemisphere(allPoints, p));
            const bounds = L.latLngBounds(
                sameHemiPoints.map(point => [point.lat, point.lon])
            );
            this.map.fitBounds(bounds);
        }
    }

    toggleNoGoMode(state) {
        if (state) {
            this.map.removeControl(this.drawControl)
            this.isDrawNoGoZonesStarted = false;
            eventBus.$emit('end-edit-nogo-zones');
        } else {
            this.nogoZonesGroup.clearLayers();

            this.routesStore.nogoZones.forEach(zone => {
                let bounds = [[zone.north, zone.west], [zone.south, zone.east]];
                const zoneRectangle = L.rectangle(bounds, {color: 'red', weight: 1});
                this.nogoList.addLayer(zoneRectangle);
            })

            this.drawControl.addTo(this.map);
            this.isDrawNoGoZonesStarted = true;
            eventBus.$emit('begin-edit-nogo-zones');
        }
    }

    restoreNoGoZones() {
        if (!this.nogoZonesGroup) {
            console.warn('restoreNoGoZones: nogoZonesGroup not ready');
            return;
        }
        
        this.nogoZonesGroup.clearLayers();
        this.routesStore.nogoZones.forEach(zone => {
            let bounds = [[zone.north, zone.west], [zone.south, zone.east]];
            const zoneRectangle = L.rectangle(bounds, {color: 'red', weight: 1}).addTo(this.nogoZonesGroup);
            /*
            // no context menu on NoGo, it is interfering with underlying map context menu
            zoneRectangle.on('contextmenu', (e) => {                
                ContextMenu.closeContextMenu();
                const items = [
                    ContextMenuItem(
                        'Delete',
                        () => {    
                            const remainingZones = this.routesStore.nogoZones.filter(z => z !== zone);
                            this.routesStore.addNoGoZone(remainingZones);
                            eventBus.$emit('save-nogo-zones', remainingZones);
                            this.restoreNoGoZones()
                        }
                    )
                ];

                ContextMenu.contextMenuHandler({
                    x: e.originalEvent.clientX,
                    y: e.originalEvent.clientY,
                    items
                });

                L.DomEvent.stop(e);
            });
            */        
        })
    }

    saveNoGoZones() {
        let restrictedZones = [];
        this.nogoList.getLayers().forEach(area => {
            let bounds = area.getBounds()
            let restZone = {
                "south": bounds.getSouth(),
                "north": bounds.getNorth(),
                "west": bounds.getWest(),
                "east": bounds.getEast()
            }
            restrictedZones.push(restZone)
            this.nogoList.clearLayers()
        })

        this.routesStore.addNoGoZone(restrictedZones)
        eventBus.$emit('save-nogo-zones', restrictedZones)
        this.restoreNoGoZones()
    }

    drawMapLayers() {
        eventBus.$emit('draw-map-layers')
    }
}